import { WarningAmber } from '@mui/icons-material';
import { Avatar, CardContainer, Button } from 'finara-components';

import { PendingAction } from '@/data/admin/dashboard/dashboardData';

interface PendingActionsProps {
  actions: PendingAction[];
  onViewAll?: () => void;
}

const getActionColor = (actionType: PendingAction['actionType']) => {
  switch (actionType) {
    case 'KYC':
      return 'text-yellow-600';
    case 'ADELANTO':
      return 'text-red-600';
    case 'BANCARIO':
      return 'text-blue-600';
    default:
      return 'text-gray-600';
  }
};

export const PendingActions: React.FC<PendingActionsProps> = ({ actions, onViewAll }) => {
  return (
    <CardContainer className="h-fit">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <WarningAmber className="text-yellow-600" fontSize="small" />
          <h3 className="text-sm font-semibold text-brand-white">Acciones Pendientes</h3>
        </div>
        <Button variant="white" size="small" onClick={onViewAll}>
          Ver todas las alertas
        </Button>
      </div>

      <p className="text-[12.5px] text-muted mb-6">Empleados que requieren atención</p>

      {/* Actions Table */}
      <div className="border border-border rounded-lg overflow-hidden">
        {actions.map((action, index) => (
          <div
            key={action.id}
            className={`flex items-center justify-between px-4 py-3 hover:bg-black/5 dark:hover:bg-white/5 ${index < actions.length - 1 ? 'border-b border-border' : ''}`}
          >
            <div className="md:flex items-center justify-between md:w-7/12">
              <div className="flex items-center gap-3">
                <Avatar
                  initials={action.initials}
                  title={action.employeeName}
                  subtitle={action.department}
                  size="large"
                  avatarBgColor="bg-brand-blue/30"
                  avatarTextColor="text-brand-white"
                />
              </div>

              <div className="md:mx-4 mt-2 md:!mt-0">
                <div className={`text-[12.25px] font-medium ${getActionColor(action.actionType)}`}>
                  {action.action}
                </div>
                <div className="text-[10.5px] text-muted">{action.actionSubtitle}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </CardContainer>
  );
};
